import React, { useEffect, useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";

const CounterSection = () => {
  const [count1, setCount1] = useState(0);
  const [count2, setCount2] = useState(0);
  const [count4, setCount4] = useState(0);

  useEffect(() => {
    const interval1 = setInterval(() => {
      setCount1(prev => (prev < 30 ? prev + 1 : prev));
    }, 10);

    const interval2 = setInterval(() => {
      setCount2(prev => (prev < 50 ? prev + 1 : prev));
    }, 5);

    const interval4 = setInterval(() => {
      setCount4(prev => (prev < 15 ? prev + 1 : prev));
    }, 50);

    return () => {
      clearInterval(interval1);
      clearInterval(interval2);
      clearInterval(interval4);
    };
  }, []);

  return (
    <>
      <style>
        {`
          .counter-wrapper {
            background-size: cover;
            background-position: center center;
            position: relative;
            height: 190px;
            min-height: 188px;
            border-radius: 100px;
            width: 100%;
            overflow: hidden;
          }

          .counter-wrapper::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(20, 20, 20, 0.43);
            border-radius: 100px;
            z-index: 1;
          }

          .counter-wrapper:after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background: #03193cba;
            border-radius: 100px;
            z-index: 2;
          }

          .counter-inner {
            position: relative;
            z-index: 3;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
          }

          .count-icon {
            font-size: 48px;
            color: white;
            display: inline-block;
            margin-bottom: 8px;
          }

          .count {
            font-family: 'Josefin Sans', sans-serif;
            font-size: 35px;
            font-weight: bold;
            color: white;
            margin: 5px 0;
          }

          .count span {
            font-size: 35px;
            font-weight: bold;
            color: white;
          }

          .counter-label {
            color: rgba(255, 255, 255, 0.9);
            font-size: 16px;
            font-weight: 500;
          }

          .counter-container {
            max-width: 1400px;
            margin: 0 auto;
            padding: 0 20px;
            width: 100%;
          }

          .counter-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
            width: 100%;
          }

          .counter-item {
            text-align: center;
            padding: 10px;
          }

          @media (min-width: 1200px) {
            .counter-wrapper {
              height: 190px;
              border-radius: 100px;
            }
            .counter-wrapper::before,
            .counter-wrapper:after {
              border-radius: 100px;
            }
            .count {
              font-size: 35px;
            }
            .count span {
              font-size: 35px;
            }
            .count-icon {
              font-size: 48px;
            }
          }

          @media (min-width: 992px) and (max-width: 1199px) {
            .counter-wrapper {
              height: 180px;
              border-radius: 80px;
            }
            .counter-wrapper::before,
            .counter-wrapper:after {
              border-radius: 80px;
            }
            .count {
              font-size: 32px;
            }
            .count span {
              font-size: 32px;
            }
            .count-icon {
              font-size: 44px;
            }
            .counter-label {
              font-size: 15px;
            }
          }

          @media (min-width: 768px) and (max-width: 991px) {
            .counter-wrapper {
              height: auto;
              min-height: auto;
              border-radius: 60px;
              padding: 30px 0;
            }
            .counter-wrapper::before,
            .counter-wrapper:after {
              border-radius: 60px;
            }
            .counter-grid {
              grid-template-columns: repeat(3, 1fr);
              gap: 30px;
            }
            .count {
              font-size: 30px;
            }
            .count span {
              font-size: 30px;
            }
            .count-icon {
              font-size: 42px;
            }
            .counter-label {
              font-size: 14px;
            }
            .counter-container {
              padding: 0 30px;
            }
          }

          @media (min-width: 576px) and (max-width: 767px) {
            .counter-wrapper {
              height: auto;
              min-height: auto;
              border-radius: 40px;
              padding: 25px 0;
            }
            .counter-wrapper::before,
            .counter-wrapper:after {
              border-radius: 40px;
            }
            .counter-grid {
              grid-template-columns: repeat(3, 1fr);
              gap: 25px;
            }
            .count {
              font-size: 28px;
            }
            .count span {
              font-size: 28px;
            }
            .count-icon {
              font-size: 38px;
              margin-bottom: 5px;
            }
            .counter-label {
              font-size: 13px;
            }
            .counter-container {
              padding: 0 20px;
            }
          }

          @media (max-width: 575px) {
            .counter-wrapper {
              height: auto;
              min-height: auto;
              border-radius: 30px;
              padding: 20px 0;
            }
            .counter-wrapper::before,
            .counter-wrapper:after {
              border-radius: 30px;
            }
            .counter-grid {
              grid-template-columns: repeat(2, 1fr);
              gap: 20px;
            }
            .count {
              font-size: 24px;
            }
            .count span {
              font-size: 24px;
            }
            .count-icon {
              font-size: 32px;
              margin-bottom: 4px;
            }
            .counter-label {
              font-size: 11px;
            }
            .counter-container {
              padding: 0 15px;
            }
          }

          @media (max-width: 400px) {
            .counter-wrapper {
              border-radius: 20px;
              padding: 20px 0;
            }
            .counter-wrapper::before,
            .counter-wrapper:after {
              border-radius: 20px;
            }
            .counter-grid {
              grid-template-columns: 1fr;
              gap: 20px;
            }
            .count {
              font-size: 28px;
            }
            .count span {
              font-size: 28px;
            }
            .count-icon {
              font-size: 36px;
              margin-bottom: 5px;
            }
            .counter-label {
              font-size: 13px;
            }
            .counter-container {
              padding: 0 20px;
            }
          }

          @media (max-width: 320px) {
            .counter-wrapper {
              border-radius: 15px;
            }
            .counter-wrapper::before,
            .counter-wrapper:after {
              border-radius: 15px;
            }
            .count {
              font-size: 24px;
            }
            .count span {
              font-size: 24px;
            }
            .count-icon {
              font-size: 32px;
            }
            .counter-label {
              font-size: 12px;
            }
          }

          @media (max-height: 500px) and (orientation: landscape) {
            .counter-wrapper {
              padding: 15px 0;
            }
            .counter-grid {
              gap: 15px;
            }
            .count {
              font-size: 22px;
            }
            .count span {
              font-size: 22px;
            }
            .count-icon {
              font-size: 28px;
              margin-bottom: 2px;
            }
            .counter-label {
              font-size: 11px;
            }
          }
        `}
      </style>

      <div
        className="counter-wrapper"
        style={{
          backgroundImage: "url('/img/servicebusiness.jpg')",
        }}
      >
        <div className="counter-inner">
          <div className="counter-container">
            <div className="counter-grid">
              <div className="counter-item">
                <i className="bi bi-people count-icon"></i>
                <div className="count">
                  <span>{count1}</span>+
                </div>
                <div className="counter-label">Happy Clients</div>
              </div>

              <div className="counter-item">
                <i className="bi bi-building count-icon"></i>
                <div className="count">
                  <span>{count2}</span>+
                </div>
                <div className="counter-label">Complete Projects</div>
              </div>

              <div className="counter-item">
                <i className="bi bi-graph-up count-icon"></i>
                <div className="count">
                  <span>{count4}</span>+
                </div>
                <div className="counter-label">Employees</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CounterSection;